// ช่องพิมพ์ข้อความ — Enter ส่ง, Shift+Enter ขึ้นบรรทัดใหม่, ปุ่มหยุดระหว่าง AI ตอบ
import React, { useEffect, useRef } from "react";
import { Icon } from "../ui";

export default function Composer({ value, onChange, onSend, onStop, busy, disabled, placeholder = "ถามอะไรก็ได้...", autoFocus, footer, big }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, 220) + "px";
  }, [value]);
  useEffect(() => {
    if (autoFocus && ref.current) ref.current.focus();
  }, [autoFocus]);
  const canSend = !busy && !disabled && value.trim().length > 0;
  return (
    <div className={"composer" + (big ? " is-big" : "")}>
      <textarea
        ref={ref}
        rows={1}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter" && !e.shiftKey && !e.nativeEvent.isComposing) {
            e.preventDefault();
            if (canSend) onSend();
          }
        }}
        aria-label="ข้อความ"
      />
      <div className="composer-bar">
        <div className="composer-tools">
          <button type="button" className="chip-btn" disabled title="แนบไฟล์ (เร็วๆ นี้)">
            <Icon name="paperclip" size={16} />
          </button>
          <button type="button" className="chip-btn" disabled title="ค้นหาเว็บ (เร็วๆ นี้)">
            <Icon name="globe" size={16} />
            <span>ค้นเว็บ</span>
          </button>
          <button type="button" className="chip-btn" disabled title="สั่งด้วยเสียง (เร็วๆ นี้)">
            <Icon name="mic" size={16} />
          </button>
          {footer}
        </div>
        {busy ? (
          <button type="button" className="send-btn is-stop" onClick={onStop} aria-label="หยุด">
            <Icon name="stop" size={16} stroke={2.4} />
          </button>
        ) : (
          <button type="button" className="send-btn" onClick={onSend} disabled={!canSend} aria-label="ส่ง">
            <Icon name="send" size={18} stroke={2.4} />
          </button>
        )}
      </div>
    </div>
  );
}
